import styled from 'styled-components'
import { Modal } from 'antd'
import { blue } from '../../../color'

export const ModalWrapper = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  }

  .ant-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-title {
    font-weight: 600;
  }
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 600px;

  .search-section {
    padding: 20px 24px;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
  }

  .content-section {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  .user-selector {
    flex: 1;
    border-right: 1px solid #f0f0f0;
    padding: 20px 24px;
    overflow-y: auto;
  }

  .selected-users {
    width: 320px;
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    background: #fff;

    .section-title {
      font-size: 14px;
      font-weight: 600;
      color: #555;
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .user-list {
      flex: 1;
      overflow-y: auto;
      margin: 0 -8px;
      padding: 0 8px;
    }
  }
`

export const SelectedUserItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  margin-bottom: 4px;
  border-radius: 8px;
  transition: background 0.2s;
  
  &:hover {
    background: #f5f5f5;
  }

  .user-info {
    flex: 1;
    margin-left: 12px;
    min-width: 0;

    .display-name {
      font-size: 13px;
      font-weight: 500;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .username {
      font-size: 11px;
      color: #888;
    }
  }

  .remove-btn {
    opacity: 0;
    transition: opacity 0.2s;
    color: #ff4d4f;
    cursor: pointer;
    padding: 4px;
  }

  &:hover .remove-btn {
    opacity: 1;
  }
`
